<template>
  <div class="list_index">
    <el-row class="heads" :gutter="20">
      <el-col :span="10">
        <div class="charts">
          <div class="title">故障统计</div>
          <Fanchart/>
        </div>
      </el-col>
      <el-col :span="14">
        <div class="charts">
          <div class="title2">工单统计</div>
          <Histogram/>
        </div>
      </el-col>
    </el-row>
    <el-table stripe border :data="tableData">
      <el-table-column label="设备序列号" prop="serialNumber"></el-table-column>
      <el-table-column label="联系人" prop="contacts"></el-table-column>
      <el-table-column label="手机号" prop="phoneNumber"></el-table-column>
      <el-table-column label="地址" prop="address" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column label="报修原因" prop="problemDescription" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <p v-if="scope.row.serviceProgress == '5'">维修完成</p>
          <el-button v-else-if="scope.row.serviceProgress == '0'" type="text" @click="lookup(scope.row,0)">审核不通过</el-button>
          <el-button v-else-if="scope.row.serviceProgress == '6'" type="text" @click="lookup(scope.row,1)" style="color:#FFB35A">查看评价</el-button>
        </template>
      </el-table-column>
      <el-table-column label="描述">
        <template slot-scope="scope">
          <el-button v-if="scope.row.serviceProgress != '0'" type="text" @click="lookup(scope.row,2)">维修描述</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        layout="total, prev, pager, next, jumper"
        :current-page="page"
        :page-size="size"
        :total="count"
        @current-change="changePage"
      ></el-pagination>
    </div>
    <el-dialog :title="type == 0 ? '审核不通过原因': type == 1 ? '客户评价':'维修描述'" :visible.sync="showReasonsForRefusal" width="30%">
      <div v-if="type == 1" class="evaluate">
        <el-row>
          <el-col :span="6">
            <span class="text">客户评分：</span>
          </el-col>
          <el-col :span="12">
            <el-rate
              v-model="fraction"
              disabled
              show-score
              text-color="#ff9900">
            </el-rate>
          </el-col>
        </el-row>
        <p class="text">客户评价：{{evaluate}}</p>
      </div>
      <p v-else-if="type == 0" class="text">{{reasonsForRefusal}}</p>
      <p v-else class="text">{{closingDescription}}</p>
      <el-button class="showReasonsForRefusal yl-button" type="primary" size="small" @click="showReasonsForRefusal = false">确定</el-button>
    </el-dialog>
  </div>
</template>

<script>
import RepairService from '@/api/repair';
import Fanchart from '@/components/repairEcharts/Fanchart';
import Histogram from '@/components/repairEcharts/Histogram';
export default {
  components:{
    Fanchart,
    Histogram
  },
  data(){
    return{
      page: 1,
      count: 0,
      size:10,
      tableData:[],
      showReasonsForRefusal:false,
      reasonsForRefusal:'',
      type:Number,
      evaluate:'',
      closingDescription:'',//结束服务描述
      fraction:''
    }
  },
  methods:{
    getDataList(){
      RepairService.getCheckRepair({
        user_id:this.$store.state.user_id,
        page:this.page,
        size:this.size,
        list:['0','5','6']
      }).then(res=>{
        this.tableData = res.data.projectSiteList;
        this.count = res.data.count;
      }).catch(err=>{
        this.$message.error(err.message)
      })
    },
    changePage(page) {
      this.page = page;
      this.getDataList();
    },
    //查看审核不通过原因
    lookup(val,type){
      this.type = type;
      let _this = this;
      if(type == 0){
        this.reasonsForRefusal = val.reasonsForRefusal;
      }else if(type == 2){
        this.closingDescription = val.closingDescription
      }else{
        RepairService.getProgress({
          workOrderNo:val.workOrderNo
        }).then(res=>{
          _this.evaluate = res.data.evaluationContent;
          _this.fraction = res.data.fraction;
        }).catch(err=>{
          _this.$message.error(err.message)
        })
      }
      this.showReasonsForRefusal = true;
    }
  },
  mounted(){
    this.getDataList()
  }
}
</script>

<style lang='scss' scoped>
.heads{
  margin-bottom: 20px;
}
.showReasonsForRefusal{
  margin-top: 50px;
  margin-left: 45%;
}
.evaluate{
  .el-rate{
    margin-bottom: 20px;
  }
}
.charts{
  background:url('../../../assets/images/frame.png') no-repeat;
  background-size: 100% 100%;
  position: relative;
  padding: 20px;
  color: #fff;
  .title{
    position: absolute;
    top: 4px;
    left: 50px;
  }
  .title2{
    position: absolute;
    top: 4px;
    left: 70px;
  }
}
.text{
  font-size: 18px;
  color: #fff;
}
</style>